
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaicabs() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Cabs',
        heading: 'Prince Cabs: Pune to Mumbai Cabs',
        headingDescription: 'Prince Cabs offers comfortable and reliable Pune to Mumbai Cabs, ideal for airport transfers, business trips, family travel, and weekend getaways. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a smooth ride on the expressway, with modern amenities for added comfort. With professional drivers, on-time pickups, and flexible schedules, we guarantee a hassle-free journey from Pune to Mumbai. Enjoy affordability, safety, and convenience with Prince Cabs’ trusted Pune to Mumbai taxi service.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed to commemorate the visit of King George V and Queen Mary, the monument combines Indo-Saracenic and Islamic architectural styles. Tourists flock here to enjoy ferry rides that lead to Elephanta Caves and coastal views. It is especially stunning during sunrise and evening when the monument is beautifully lit. The surrounding area buzzes with photographers, vendors, and street performers. The Gateway symbolizes Mumbai’s rich colonial history and modern vibrancy."
  },
  {
    "title": "Marine Drive",
    "description": "Also called the ‘Queen’s Necklace,’ Marine Drive is a 3.6 km-long boulevard along the Arabian Sea, famous for its glowing streetlights at night that resemble a string of pearls. It is one of the most popular hangout spots in Mumbai for locals and tourists alike. People come here to stroll, jog, or simply watch the waves crash against the tetrapods. Sunsets from Marine Drive are breathtaking, with the skyline offering the perfect backdrop. During monsoon, the waves dramatically rise, attracting thrill-seekers. It’s a symbol of Mumbai’s spirit and charm."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island, about an hour’s ferry ride from Mumbai. These ancient rock-cut caves date back to the 5th–6th century and are dedicated primarily to Lord Shiva. The massive sculpture of Trimurti, depicting three aspects of Shiva, is the highlight. The caves also feature detailed carvings, courtyards, and pillars showcasing India’s artistic heritage. Surrounded by lush greenery and sea views, the site is both spiritual and historical. It’s a must-visit for history buffs and cultural travelers."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly known as Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887 in Gothic Revival style, it is an architectural marvel with stained glass windows, domes, and intricate carvings. It is not only a transport hub but also a symbol of Mumbai’s colonial heritage. The station comes alive at night when it is illuminated beautifully. Visitors admire its grandeur while witnessing the hustle and bustle of Mumbai’s lifeline – the local trains. It is a blend of history and modern functionality."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most famous beaches, stretching for 6 km along the Arabian Sea. It is a lively spot for families, joggers, and tourists enjoying local street food like pav bhaji, bhel puri, and ice gola. Bollywood stars often visit the area, adding glamour to the beach. Sunsets here are magical, with crowds gathering to watch the golden hues over the water. The beach also hosts cultural events and weekend fairs. Its vibrant atmosphere makes it an essential stop for those wanting to experience Mumbai’s local vibe."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered shrine situated on a small islet off the coast of Worli in Mumbai. Built in the 15th century, it houses the tomb of Pir Haji Ali Shah Bukhari, a wealthy merchant turned saint. The dargah is connected to the mainland by a narrow causeway, which gets submerged during high tide, adding to its mystique. The Indo-Islamic architecture with white domes and marble courtyards is breathtaking. Thousands of devotees, irrespective of religion, visit here daily. It’s a symbol of faith, unity, and Mumbai’s spiritual side."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park, spread over 87 sq. km, is a green oasis within bustling Mumbai. It is home to leopards, deer, birds, and lush trekking trails. Inside the park lie the Kanheri Caves, Buddhist rock-cut caves dating back to the 1st century BC. The caves were once used as monasteries and feature stupas, carvings, and meditation halls. The park also offers a toy train, boating, and cycling paths for families. It is one of the few national parks located within a metropolitan city. Nature and history blend beautifully here."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market in South Mumbai, famous for its eclectic mix of fashion, antiques, handicrafts, and food joints. It is a paradise for shoppers hunting for bargains on clothes, jewelry, and souvenirs. The street is also home to legendary cafés like Café Mondegar and Leopold Café, popular hangouts since colonial times. Tourists love the lively vibe and vibrant street culture. The Causeway reflects Mumbai’s cosmopolitan spirit, where tradition and modernity meet. It’s a must-visit for shopaholics and foodies alike."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most famous and revered temples dedicated to Lord Ganesha. Built in 1801, the temple attracts devotees from across India, including Bollywood celebrities and politicians. The idol of Ganesha here is considered very powerful and is said to fulfill wishes. Tuesdays are especially crowded, with thousands of devotees offering prayers. The temple’s gold-plated dome and intricate carvings add to its grandeur. It is both a spiritual landmark and a cultural icon of Mumbai."
  },
  {
    "title": "Chowpatty Beach & Girgaon Area",
    "description": "Chowpatty Beach, located in South Mumbai, is famous for its festive atmosphere, especially during Ganesh Visarjan when idols of Lord Ganesha are immersed here. Families gather to enjoy street food like pav bhaji, bhel puri, and kulfi. The beach is also popular for evening walks with views of Marine Drive. Nearby, Girgaon boasts traditional chawls, temples, and old markets showcasing Mumbai’s heritage. Together, Chowpatty and Girgaon highlight the city’s cultural and community spirit. They are essential stops to experience Mumbai’s local flavor."
  }
],


"services": [
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Enjoy a comfortable and spacious journey from Pune to Mumbai in our Innova cab service. Equipped with air conditioning and ample seating, this cab is ideal for families and groups looking for a smooth, reliable, and safe ride between the two cities."
    },
    {
        "name": "Pune Mumbai Cab",
        "description": "Book your Pune to Mumbai cab with ease and experience timely pickups, clean vehicles, and professional drivers. Whether for business or leisure, our cab service guarantees a hassle-free and comfortable journey tailored to your schedule."
    },
    {
        "name": "Mumbai Pune Taxi Hire",
        "description": "Hire a reliable taxi from Mumbai to Pune with flexible booking options, well-maintained cars, and experienced drivers. Perfect for daily commuters, business travelers, and tourists seeking convenient and affordable transport."
    },
    {
        "name": "Pune to Mumbai Taxi",
        "description": "Choose from a variety of taxi options for your Pune to Mumbai trip, including sedans and SUVs. Our taxis provide safe, clean, and punctual services, ensuring you reach your destination on time and with peace of mind."
    },
    {
        "name": "Mumbai to Pune Innova Crysta Cab",
        "description": "Travel in style from Mumbai to Pune in an Innova Crysta cab. Experience luxury, comfort, and professional driving service with ample luggage space and air conditioning, making your journey pleasant and stress-free."
    },
    {
        "name": "Pune to Mumbai Round Trip Cab",
        "description": "Book a round-trip cab service between Pune and Mumbai for a convenient and cost-effective travel solution. Enjoy flexible scheduling, door-to-door pickups, and the same driver and vehicle throughout your journey."
    },
    {
        "name": "Pune to Mumbai Etios Drop",
        "description": "Affordable and reliable Etios cab drop service from Pune to Mumbai. Perfect for small groups or solo travelers looking for a smooth and comfortable ride with professional drivers and timely service."
    },
    {
        "name": "Pune to Mumbai Swift Dzire Taxi Fare",
        "description": "Get transparent and competitive taxi fares for Pune to Mumbai travel in a Swift Dzire sedan. Enjoy a fuel-efficient, air-conditioned ride with courteous drivers and no hidden charges."
    },
    {
        "name": "Pune to Mumbai Dzire Cab",
        "description": "Comfortable Dzire cab service for travel between Pune and Mumbai. Suitable for couples and small families, offering smooth rides, professional drivers, and affordable pricing."
    },
    {
        "name": "Pune to Mumbai Innova Service",
        "description": "Premium Innova service for Pune to Mumbai travelers seeking spacious seating and a relaxing journey. Ideal for group travel and family trips with reliable drivers and well-maintained vehicles."
    },
    {
        "name": "Pune to Mumbai Family Taxi",
        "description": "Book family-friendly taxi services from Pune to Mumbai with extra space, child-friendly seating options, and courteous drivers to ensure a safe and comfortable trip for all age groups."
    },
    {
        "name": "Pune to Mumbai Tour Package",
        "description": "Comprehensive tour packages from Pune to Mumbai covering transportation, sightseeing, and local travel. Perfect for tourists looking to explore Mumbai’s attractions with hassle-free travel arrangements."
    },
    {
        "name": "Pune to Mumbai Affordable Taxi",
        "description": "Affordable taxi options from Pune to Mumbai designed for budget-conscious travelers without compromising on comfort or safety. Transparent pricing and reliable service guaranteed."
    },
    {
        "name": "Pune to Mumbai Airport Drop Cab",
        "description": "Pre-book your Pune to Mumbai airport drop cab for timely and stress-free transfers. Our professional drivers track your flight timings and ensure prompt pickups, making your airport journey smooth and comfortable."
    }
],
"tableData": [
    ["Pune to Mumbai Innova Cab", "Pune Mumbai Cab"],
    ["Mumbai Pune Taxi Hire", "Pune to Mumbai Taxi"],
    ["Mumbai to Pune Innova Crysta Cab", "Pune to Mumbai Round Trip Cab"],
    ["Pune to Mumbai Etios Drop", "Pune to Mumbai Swift Dzire Taxi Fare"],
    ["Pune to Mumbai Dzire Cab", "Pune to Mumbai Innova Service"],
    ["Pune to Mumbai Family Taxi", "Pune to Mumbai Tour Package"],
    ["Pune to Mumbai Affordable Taxi", "Pune to Mumbai Airport Drop Cab"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Cab Service",
        "WhyChoosedescription": "Prince Cabs provides dependable and comfortable cab services from Pune to Mumbai, perfect for business trips, airport transfers, and leisure travel with punctual pickups and smooth rides."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our well-maintained, air-conditioned cabs offer ample legroom and luggage space, ensuring a relaxing journey across the Pune-Mumbai route."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are skilled in navigating the busy highways and city traffic between Pune and Mumbai, ensuring safe and timely travel."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
        "WhyChoosedescription": "Choose from one-way, round-trip, or hourly rentals. Book easily via phone, website, or WhatsApp with customizable packages tailored to your travel needs."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "We maintain high standards of cleanliness and sanitation for every vehicle before and after trips, prioritizing your safety and comfort."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Options",
        "WhyChoosedescription": "Our pricing is competitive and upfront, with no hidden charges. Payments can be made securely via UPI, credit/debit cards, net banking, or cash."
    },
    {
        "WhyChooseheading": "Dedicated 24/7 Customer Support",
        "WhyChoosedescription": "Our support team is available round the clock to assist you throughout your Pune to Mumbai journey, ensuring hassle-free travel and prompt assistance."
    }
]






















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Pune to Mumbai cab services?',
        answer: 'Yes, Prince Cabs offers reliable and affordable cab services from Pune to Mumbai, ideal for business trips, airport transfers, and family travel.',
    },
    {
        question: 'What types of cabs are available for Pune to Mumbai travel?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit all group sizes and travel preferences.',
    },
    {
        question: 'Is the Pune to Mumbai cab ride comfortable and safe?',
        answer: 'Absolutely! Our cabs are air-conditioned, well-maintained, and driven by experienced drivers to ensure a smooth and secure journey.',
    },
    {
        question: 'Can I book a one-way or round trip cab from Pune to Mumbai?',
        answer: 'Yes, we provide both one-way and round-trip options. You can also customize your pickup time, drop location, and add stopovers if needed.',
    },
    {
        question: 'What are the charges for Pune to Mumbai cabs?',
        answer: 'Cab fares depend on the vehicle type, trip duration, and additional requests. Contact Prince Cabs for a transparent and competitive quote.',
    },
    {
        question: 'How can I book a Pune to Mumbai cab with Prince Cabs?',
        answer: 'Booking is easy—reach out via our website or phone with your travel details, and our team will help you find the best cab for your journey.',
    },
    {
        question: 'Are your cabs sanitized and suitable for intercity travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, thoroughly cleaned, and maintained to high safety and hygiene standards for intercity travel.',
    },
];

const testimonials = [
    {
        name: "Mr. Kiran Naik",
        position: "Frequent Business Traveler",
        text: "Prince Cabs has been my go-to for Pune to Mumbai travel. The service is punctual, cars are clean, and drivers are very professional.",
        image: "/img/testimonial/testimonial-thumb-mumbai-1.png",
    },
    {
        name: "Mrs. Tanvi Desai",
        position: "Airport Traveler",
        text: "Booked a cab from Pune to Mumbai Airport with Prince Cabs. Hassle-free experience, courteous driver, and arrived well on time.",
        image: "/img/testimonial/testimonial-thumb-mumbai-2.png",
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab",
  "image": "https://princecab.com/assets/images/pune-mumbai-cab.jpg",
  "description": "Book Pune to Mumbai cab with Prince Cabs – Comfortable and reliable taxi options including Innova Crysta, Dzire, Etios, and sedans. Perfect for airport drops, round trips, and family travel. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7720"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mumbai-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Cab | Airport Drop, Round Trip Taxi | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Mumbai cab service with Innova, Dzire, Etios, and SUV options. Ideal for airport drops, family trips, and one-way or round-trip travel. Affordable fare, 24/7 booking online."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Innova Cab, Pune Mumbai Cab, Mumbai Pune Taxi Hire, Pune to Mumbai Taxi, Mumbai to Pune Innova Crysta Cab, Pune to Mumbai Round Trip Cab, Pune to Mumbai Etios Drop, Pune to Mumbai Swift Dzire Taxi Fare, Pune to Mumbai Dzire Cab, Pune to Mumbai Innova Service, Pune to Mumbai Family Taxi, Pune to Mumbai Tour Package, Pune to Mumbai Affordable Taxi, Pune to Mumbai Airport Drop Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaicabs;